import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Grid from "../common/layout/grid";

import "./concurso.css";

import { selectDezena } from "../reducers/concurso/concursoActions";

const leftPad = require("left-pad");

class ConcursoCartela extends Component {
  constructor(props) {
    super(props);
    this.onClickNumber = this.onClickNumber.bind(this);
    this.renderButton = this.renderButton.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  onClickNumber(btn, clickedNumber) {
    //const arr = this.state.selecionados
    const selectedNumbers = this.props.dezenasSel;

    //Verificar se ja existe no array, se existe, remove caso contrário, adiciona
    const exists = selectedNumbers.some((item) => item === clickedNumber);

    if (exists) {
      selectedNumbers.splice(selectedNumbers.indexOf(clickedNumber), 1);
    } else {
      //if (this.state.selecionados.length < this.props.maxDezenas ) {
      if (selectedNumbers.length < this.props.maxDezenas) {
        selectedNumbers.push(clickedNumber);
      }
    }

    //this.setState({ selecionados:arr })
    this.props.selectDezena(selectedNumbers);
  }

  renderButton(name, text) {
    let className = "btn btn btn-cartela";

    //const arr = this.state.selecionados
    const arr = this.props.dezenasSel;
    const exists = arr.some((item) => item === text);

    className += `${exists ? " btn-selected" : ""}`;

    return (
      <button
        type="button"
        id={name}
        className={className}
        style={{ position: "relative" }}
        onClick={(btn) => this.onClickNumber(btn, text)}
      >
        {text}
        <img style={{ display: "none" }} src="/assets/icons/ball.svg" />
      </button>
    );
  }

  renderButtons() {
    var rows = [];
    var row = [];
    var j = 0;
    var landscapeW = 10;

    if (window.innerWidth < 600) {
      landscapeW = 9;
    }

    const qtdCols = this.props.orientation == "landscape" ? landscapeW : 5;

    for (
      var i = this.props.concursoType.objTipoJogo.tnyNumeroMin;
      i <= this.props.concursoType.objTipoJogo.tnyNumeroMax;
      i++
    ) {
      row.push(
        <td key={`btn-${i}`}>
          {this.renderButton(`btn-${i}`, leftPad(i, 2, 0))}
        </td>
      );
      j += 1;

      if (j == qtdCols) {
        rows.push(
          <tr className="cartela-row" key={`row-${i}`}>
            {row}
          </tr>
        );
        j = 0;
        row = [];
      }
    }

    if (j > 0) {
      rows.push(
        <tr className="cartela-row" key={`row-${i}`}>
          {row}
        </tr>
      );
    }

    return (
      <table>
        <tbody>{rows}</tbody>
      </table>
    );
  }

  renderButtonsNewDeisgn() {
    const arr = [];

    for (
      var i = this.props.concursoType.objTipoJogo.tnyNumeroMin;
      i <= this.props.concursoType.objTipoJogo.tnyNumeroMax;
      i++
    ) {
      arr.push(i);
    }

    return (
      <div className="cartela-buttons">
        {arr.map((number) => {
          return this.renderButton(`btn-${number}`, leftPad(number, 2, 0));
        })}
      </div>
    );
  }

  render() {
    return (
      <Grid cols={this.props.cols}>
        <div className="cartela">
          {this.props.isNewDesign
            ? this.renderButtonsNewDeisgn()
            : this.renderButtons()}
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    objUser: state.usuario.objUser,
    concursoScreen: state.concurso.concursoScreen,
    concursoType: state.concurso.concursoType,
    dezenasSel: state.concurso.dezenasSel,
    isNewDesign: state.settings.isNewDesign,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ selectDezena }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ConcursoCartela);



// WEBPACK FOOTER //
// ./src/concurso/concursoCartela.jsx